module.exports = __webpack_public_path__ + "img/信阳市-c.16fc0de3.png";